import { TOptions } from "i18next";
import { FieldError, Merge } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FieldsErrorEnum, getEnum } from "@/i18n/translations";

type ErrorMessageFunction = (
  errorField: FieldError | Merge<FieldError, unknown> | undefined,
  options?: TOptions,
) => string;

export const useGetErrorMessage = (): ErrorMessageFunction => {
  const { t: tCommon } = useTranslation();

  const getErrorMessage: ErrorMessageFunction = (
    errorField: FieldError | Merge<FieldError, unknown> | undefined,
    options?: TOptions,
  ): string => {
    if (!errorField?.message) return "";

    // Check if message contains parameters
    if (typeof errorField.message === "string" && errorField.message.includes("|")) {
      const [errorCode, ...params] = errorField.message.split("|");
      const enumValue = getEnum(FieldsErrorEnum, errorCode);

      // Get the translated message with just the raw parameters
      return tCommon(`errors.fields.${enumValue}`, {
        ...options,
        min: params[0],
        max: params[1],
      });
    }

    // Handle regular error messages
    const enumValue = getEnum(FieldsErrorEnum, errorField.message as string);
    return tCommon(`errors.fields.${enumValue}`, options || {});
  };

  return getErrorMessage;
};
